// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BSUmQqyy08siOyKtnzmg{margin-top:-8px;margin-bottom:32px}.xaThe8QGMJURr6xRbL_6{margin-top:-4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BSUmQqyy08siOyKtnzmg`,
	"wrapAutoRechargeBtn": `xaThe8QGMJURr6xRbL_6`
};
export default ___CSS_LOADER_EXPORT___;
